import React from "react";
import { Icon } from "@chakra-ui/react";

/**
 * Solid left-pointing back arrow from Figma `Icon/Back Arrow (Left)`.
 * Original artwork is a 16×16 path; it's mounted inside a 24×24 viewBox
 * with a `translate(4,4)` offset to match the 4px inset the design uses
 * so the icon slots directly into the standard 24×24 icon size.
 */
export const BackArrowLongIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        transform="translate(4 4)"
        d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
        fill="currentColor"
      />
    </Icon>
  );
};
